import React from "react";
import { Container, Row, Col } from "reactstrap";
import Lottie from "react-lottie-player";
import lottieJson from "../Assessment/success.json";

const DietPlanWaitingScreen = () => {
  return (
    <Container>
      <Row className="min-vh-90 justify-content-center align-items-center text-center">
        <Col>
          <Lottie
            loop={false}
            animationData={lottieJson}
            play
            style={{ height: 130 }}
            className="success-lottie"
          />
          {/* <h3 className='mt-3 mb-3 analyzing-title'>{onSuccessText ? 'We are all set!' : 'Analyzing...'}</h3> */}
          <p className="success-p">Your Diet Plan is being generated. Please check after some time!.</p>
        </Col>
      </Row>
    </Container>
  );
};

export default DietPlanWaitingScreen;
